import Divider from '../../common/Divider';
import SectionTitle from '../../common/SectionTitle';
import StaffCard from '../../common/StaffCard';

import PlaceholderImage from '../../../assets/images/placeholder.webp';

const Team = () => {

    return (
        <section className='py-16 flex flex-col items-center'>
            <SectionTitle text={'Sport Bestuur'} light={false} />
            <Divider />
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 py-8'>
                {/* 2x4 bestuur leden */}
                <StaffCard name={'Björn Peeters'} role={'Voorzitter'} picture={PlaceholderImage} email={'bjorn.peeters@robinhoodboechout.be'} />
                <StaffCard name={'Bart Kwick'} role={'Ondervoorzitter'} picture={PlaceholderImage} email={'bart.kwick@robinhoodboechout.be'} />
                <StaffCard name={'Ann Knapen'} role={'Secretaris'} picture={PlaceholderImage} email={'ann.knapen@robinhoodboechout.be'} />
                <StaffCard name={'Pieter Markey'} role={'Penningmeester (afgevaardigde vzw)'} picture={PlaceholderImage} email={'voorzitter.vzw@robinhoodboechout.be'} />
                <StaffCard name={'Ulrik Van Oosterwijck'} role={'Materiaalmeester'} picture={PlaceholderImage} email={'ulrik.vanoosterwijck@robinhoodboechout.be'} />
                <StaffCard name={'Yorick Cleerbout'} role={'Webmaster'} picture={PlaceholderImage} email={'yorick.cleerbout@robinhoodboechout.be'} />
            </div>

            <SectionTitle text={'VZW Bestuur'} light={false} />
            <Divider />
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 pt-8'>
                {/* 1x3 VZW leden */}
                <StaffCard name={'Pieter Markey'} role={'Voorzitter'} picture={PlaceholderImage} email={'voorzitter.vzw@robinhoodboechout.be'}/>
                <StaffCard name={'Tom Markey'} role={'Penningmeester'} picture={PlaceholderImage} email={'tom.markey@robinhoodboechout.be'} />
                <StaffCard name={'Tom Mostmans'} role={'Secretaris'} picture={PlaceholderImage} email={'tom.mostmans@robinhoodboechout.be'}/>
            </div>

        </section>
    );
};

export default Team;